




























































































import { Prop, Vue, Component, Watch } from 'vue-property-decorator';
import Uploader from '@/components/next/NewUploader.vue';
import VoteButton from '@/components/next/VoteButtonNew.vue';
import { shareList } from '../api';
import { FileType } from '@/common/ts/enum';
import { isWeiXin } from '@/common/ts/common';
import { Toast, Popup, ImagePreview } from 'vant';
Vue.use(Popup);
@Component({
  components: {
    Uploader,
    VoteButton,
  },
})
export default class Home extends Vue {
  @Prop({ default: FileType.Image }) fileType!: FileType;
  userMessage: any = {};
  data: any[] = [];
  tab: any = [{ text: '打卡记录' }, { text: '中奖记录' }];
  mounted() {
    const unionId = window.localStorage.getItem('unionid');
    const udid = window.udid;
    shareList(unionId + '', this.$route.query.id + '', udid + '').then(
      (res: any) => {
        this.userMessage = res.data.userMessage;
        this.data = res.data.data;
      },
    );
  }
  updateZan() {
    window.location.reload();
  }
  onUploadFileClick(fileUrl: string, type: FileType) {
    if (type === FileType.Image) {
      ImagePreview({
        images: [fileUrl],
        showIndicators: false,
        showIndex: false,
      });
    }
  }
  goto() {
    this.$router.push('activity');
  }
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '“倡节俭 扬新风 赏中秋 庆国庆”',
      url: location.href,
      subtitle: `快来为我点赞吧！`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '“倡节俭 扬新风 赏中秋 庆国庆”',
        subtitle: `快来为我点赞吧！`,
        image: cover,
      });
    }
  }
}
